<clx-row type="buttons" ng-reflect-type="buttons">
    <clx-item>
        <clx-button
            test-id="license.details.addactivationid.button"
            (click)="openAddActivationId()"
            i18n="@@license.details.addactivationid.button"
            has-privileges="PlantLicenseManage"
        >Add new Feature</clx-button>
        <clx-button
            *ngIf="licensedFeatures?.length > 0"
            test-id="license.details.download.button"
            i18n="@@license.details.download.button"
            (click)="startDownload()"
        >Download License</clx-button>
    </clx-item>
</clx-row>
<clx-form [data]="data" [disableChangeChecking]="true">
    <clx-row>
        <clx-label
            i18n="@@license.details.activationkey.label"
            test-id="license.details.activationkey.label"
        >Activation Key:</clx-label>
        <clx-input name="activationKey" mode="read" test-id="license.details.activationkey.input"></clx-input>
    </clx-row>
    <clx-row>
        <clx-label
            i18n="@@license.details.licensedfeatures.label"
            test-id="license.details.licensedfeatures.label"
        >Licensed features:</clx-label>
        <clx-input name="licensedFeaturesFormatted" mode="read" test-id="license.details.licensedfeatures.input"></clx-input>
    </clx-row>
    <clx-row>
        <clx-label  i18n="@@license.details.plantfeaturelicensekeys.label">License Keys:</clx-label>
        <clx-item>
            <clx-data-grid
                [data]="source"
                [showFilter]="false"
                [showSearchPanel]="false"
                [showGroupPanel]="false"
                [showColumnChooser]="false"
                [selection]="{ mode : 'none' }"
                [remoteOperations]="remoteOperations"
                [showHeaderFilter]="false"
                [showSearchPanel]="true"
                [version]="2"
                id="licens-details-list"
                test-id="license.details.datdagrid"
            >
                <clx-grid-column
                    dataField="activationId"
                    dataType="string"
                    i18n-caption="@@license.details.id-list.column.caption.activationid"
                    caption="Activation ID"
                    [allowSearch]="true"
                >
                    <ng-template let-data="item">
                        {{data.displayValue}}
                    </ng-template>
                </clx-grid-column>

                <clx-grid-column
                    dataField="licenseServer"
                    dataType="string"
                    i18n-caption="@@license.list.column.caption.licensserver"
                    caption="License server"
                    [allowSearch]="false"
                >
                    <ng-template let-data="item">
                        {{data.displayValue}}
                    </ng-template>
                </clx-grid-column>

                <clx-grid-column
                    dataField="licenseServerPlantId"
                    dataType="string"
                    i18n-caption="@@license.list.column.caption.licensserverplantid"
                    caption="License server plant ID"
                    [allowSearch]="false"
                >
                    <ng-template let-data="item">
                        {{data.displayValue}}
                    </ng-template>
                </clx-grid-column>

                <clx-grid-column
                    dataField="features"
                    dataType="string"
                    i18n-caption="@@license.list.column.caption.features"
                    caption="Features"
                    [allowSorting]="false"
                    [allowSearch]="false"
                >
                    <ng-template let-data="item">
                        {{data.value.join(',')}}
                    </ng-template>
                </clx-grid-column>

                <clx-grid-column
                    dataField="createDate"
                    dataType="string"
                    i18n-caption="@@license.details.id-list.column.caption.createdate"
                    caption="Create date"
                    [allowSorting]="true"
                    [allowSearch]="false"
                >
                    <ng-template let-data="item">
                        {{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}
                    </ng-template>
                </clx-grid-column>
                
                <clx-grid-column
                    *ngIf="hasPrivSystemAdministrator === true"
                    dataField="createUser"
                    dataType="string"
                    i18n-caption="@@license.details.id-list.column.caption.createUser"
                    caption="Created by"
                    [allowSearch]="true"
                >
                </clx-grid-column>
            </clx-data-grid>
        </clx-item>
    </clx-row>
</clx-form>


<dx-popup
    [showTitle]="true"
    i18n-title="@@license.addId.popup.title"
    title="Create Controller License File"
    [(visible)]="isPopUpVisible"
    [width]="400"
    height="auto"
>
    <div *dxTemplate="let data of 'content'">
        <loader target=".dx-overlay-content" [show]="showLoader"></loader>
        <messages name="popup-messages"></messages>
        <clx-form [disableChangeChecking]="true" *ngIf="isPopUpVisible">
            <clx-row>
                <clx-label i18n="@@license.addId.popup.activation-key.label">Activation Id</clx-label>
                <clx-input name="licensekey" [(ngModel)]="newActivationId" test-id="license.add-activation-id.popup.licensekey.input">
                </clx-input>
            </clx-row>
            <clx-row type="buttons">
                <clx-button
                    (onClick)="validateActivationId()"
                    [disabled]="!newActivationId ? true : null"
                    test-id="license.add-activation-id.popup.validate-id.button"
                    i18n="@@license.addId.popup.validate-activation-id.button"
                >Validate License</clx-button>
                <clx-button
                    (onClick)="addActivationId()"
                    [disabled]="!newFeatures || !newFeatures.length ? true : null" 
                    test-id="license.add-activation-id.popup.add-id.button"
                    i18n="@@license.addId.popup.add-activation-key.button"
                >Create License</clx-button>
            </clx-row>
        </clx-form>
    </div>
</dx-popup>